import * as Yup from "yup"

export const MIN_LENGTH = 10

// BDSJEA-230: unica fuente de verdad para la politica de clave del lado
// cliente. Cada regla define su propio check() para el checklist visual
// (components/Input/PasswordPolicyChecklist) y para el validationSchema de
// Yup (buildValidationSchema), asi no se pueden desincronizar. La politica
// real la valida siempre el backend (ClaveService.validar) -- esto es solo
// feedback inmediato. BDSJEA-129
//
// Dos reglas del backend quedan afuera / con tratamiento especial aca:
// - Coincidir con la clave actual: SI esta cubierta (rule "not-current"),
//   via this.parent.claveActual en el test de Yup (campo hermano dentro del
//   mismo values), en vez de Yup.ref.
// - Historial de las ultimas 5 claves: el cliente nunca tiene ese historial
//   ni la clave vigente en texto plano, no es verificable aca. Sigue
//   mostrandose solo al hacer submit, via el Alert de error que ya devuelve
//   el backend (err.message en CambiarClave.js).
export const passwordRules = [
  {
    id: "length",
    label: `Al menos ${MIN_LENGTH} caracteres`,
    check: clave => clave.length >= MIN_LENGTH,
  },
  {
    id: "lowercase",
    label: "Una minúscula",
    check: clave => /[a-z]/.test(clave),
  },
  {
    id: "uppercase",
    label: "Una mayúscula",
    check: clave => /[A-Z]/.test(clave),
  },
  {
    id: "digit",
    label: "Un número",
    check: clave => /[0-9]/.test(clave),
  },
  {
    id: "no-username",
    label: "No puede contener tu nombre de usuario",
    // Si todavia no se cargo el username (whoami async sin resolver), la
    // regla no se puede evaluar: se considera cumplida (no se puede probar
    // que la viola) en vez de mostrar un falso rojo.
    check: (clave, { username } = {}) =>
      !username || !clave.toLowerCase().includes(username.toLowerCase()),
  },
  {
    id: "not-current",
    label: "Distinta de tu clave actual",
    check: (clave, { claveActual } = {}) =>
      !claveActual || clave !== claveActual,
  },
]

export const buildValidationSchema = username =>
  Yup.object({
    claveActual: Yup.string().required("Ingresá tu clave actual"),
    claveNueva: passwordRules.reduce(
      (schema, rule) =>
        schema.test(rule.id, rule.label, function (value) {
          return rule.check(value || "", {
            username,
            claveActual: this.parent.claveActual,
          })
        }),
      Yup.string().required("Ingresá la clave nueva"),
    ),
    claveNuevaRepetida: Yup.string()
      .required("Repetí la clave nueva")
      .oneOf([Yup.ref("claveNueva")], "Las dos claves no coinciden"),
  })
